import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { userActions } from 'store/slices/users/users.slice'
import FacilityFormTemplate from 'templates/FacilityFormTemplate'
import { ClientProfileContainer } from './ClientProfile.styled'
import ClientProfileForm from './ClientProfileForm'
import { useAmplitude } from 'hooks/useAmplitude'
import { AMPLITUDE_EVENTS } from 'amplitude/events'

const ClientProfile = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const [locationId, setLocationId] = useState<string>('')
  const [clientId, setClientId] = useState<string>('')
  const { logEvent } = useAmplitude()

  useEffect(() => {
    if (location.pathname) {
      const path = location.pathname
      const locationPath = path.split('locations/')
      const locationIdPath = locationPath[1].split('/settings')
      const clientIdPath = locationPath[1].split('/clients/')
      setLocationId(locationIdPath[0])
      setClientId(clientIdPath[1])
      if (clientIdPath[1]) {
        dispatch(userActions.getUserProfile(parseInt(clientIdPath[1])))
      }
      logEvent(AMPLITUDE_EVENTS.CLIENT_PROFILE_PAGE_EVENT, {
        location: locationIdPath[0],
        client_id: clientIdPath[1],
      })
    }
  }, [location])

  return (
    <FacilityFormTemplate>
      <ClientProfileContainer>
        <ClientProfileForm locationId={locationId} clientId={clientId} />
      </ClientProfileContainer>
    </FacilityFormTemplate>
  )
}

export default ClientProfile
